import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Image, Button, Modal } from "react-bootstrap";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import ViewPort from "../../../../../../../_helpers/Enums/ViewPortEnum";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import { PreBuiltPkg } from "../Models/PreBuiltPkg";
import moment from "moment";
import ValidPackageRange from "../ValidPackageRange";
interface props {
  pbPackage: PreBuiltPkg;
  priceSubText?: string;
  onSelectedPackage: (vendor: any) => void;
  stacked: boolean;
  simpleView: boolean;
}

const PackagesCard: React.FC<props> = (props) => {
  const { viewPortBreakPoint, style } = useContext(WidgetContext);

  const { pbPackage, onSelectedPackage, priceSubText, simpleView } = props;
  const [errorsImg, setErrorsImg] = useState<string | undefined>();
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const [fromPrice, setFromPrice] = useState<number>(Number.MAX_VALUE);

  // return (<div style={{backgroundColor: "pink", height: "200px", width: "200px"}}></div>);

  return (
    <React.Fragment>
      {/* Mobile Unstacked */}
      {viewPortBreakPoint < ViewPort.lg && !props.stacked && (
        <Row className="simple-card-container mobile-card-border">
          {false && (
            <Col xs={5}>
              <div className="w-100 pb-3">
                <p
                  className="w-100 p-1 pl-2"
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(208,205,212,.75)",
                  }}
                >
                  Card Text
                </p>
                <Image
                  className="d-flex mobile-lodging-image"
                  src={errorsImg ? errorsImg : (pbPackage.packageImageUrl ? pbPackage.packageImageUrl : placeholderImgUrl)}
                  onError={() => setErrorsImg(placeholderImgUrl)}
                  fluid
                />
              </div>
            </Col>
          )}

          <Col xs={12} className="pl-3 pb-3 d-flex flex-column align-items-center">
            <ValidPackageRange 
              packageName={pbPackage.packageName}
              fromPrice={pbPackage.fromPrice}
              validToTravelFrom={pbPackage.validToTravelFrom}
              validToTravelEnd={pbPackage.validToTravelEnd}
              fontColor={style.fontColor}
            />

            {/* Feature text */}
            {!simpleView && (
              <div className="w-100">
                <div className="w-100 d-flex justify-content-start feature-text">
                  <i
                    className="fas fa-check pl-2"
                    style={{
                      fontSize: "20px",
                      marginRight: "30px",
                      color: "green",
                    }}
                  />
                  {pbPackage.bullet1}
                </div>

                <div className="w-100 d-flex justify-content-start feature-text">
                  <i
                    className="fas fa-check pl-2"
                    style={{
                      fontSize: "20px",
                      marginRight: "30px",
                      color: "green",
                    }}
                  />
                  {pbPackage.bullet2}
                </div>

                <div className="w-100 d-flex justify-content-start feature-text">
                  <i
                    className="fas fa-check pl-2"
                    style={{
                      fontSize: "20px",
                      marginRight: "30px",
                      color: "green",
                    }}
                  />
                  {pbPackage.bullet3}
                </div>
              </div>
            )}

            <div className="w-100 px-4">
              <Button
                className="w-100 widget-font m-0 p-0"
                variant="primary"
                block
                //size="lg"
                style={{
                  backgroundColor: "#EE6E24",
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px",
                  // marginTop: "50px",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  border: "none",
                  marginBottom: "15px",
                  padding: "6px",
                }}
                onClick={() => onSelectedPackage(pbPackage)}
              >
                View Package
              </Button>
            </div>
          </Col>
        </Row>
      )}

      {/* Desktop */}
      {viewPortBreakPoint >= ViewPort.lg && !props.stacked && (
        <Row className="card-container">
          <Col xs={12}>
            <Row className="d-flex lodging-card">
              <Col xs={6}>
                <div className="w-100">
                  {/* <p
                    className="p-1 px-3 text-center"
                    style={{
                      position: "absolute",
                      backgroundColor: "rgba(208,205,212,.75)",
                    }}
                  >
                    Card Text
                  </p> */}
                  <Image
                    className="d-flex lodging-image"
                    src={errorsImg ? errorsImg : (pbPackage.packageImageUrl ? pbPackage.packageImageUrl : placeholderImgUrl)}
                    onError={() => setErrorsImg(placeholderImgUrl)}
                    fluid
                  />
                </div>
              </Col>

              <Col className="p-3 d-flex flex-column justify-content-between align-items-center" xs={6}>
                <ValidPackageRange 
                  packageName={pbPackage.packageName}
                  fromPrice={pbPackage.fromPrice}
                  validToTravelFrom={pbPackage.validToTravelFrom}
                  validToTravelEnd={pbPackage.validToTravelEnd}
                  fontColor={style.fontColor}
                />

                {/* Feature text */}
                {!simpleView && (
                  <div className="w-100">
                    <div className="w-100 d-flex justify-content-start feature-text">
                      <i
                      className="fas fa-check pl-2"
                      style={{
                        fontSize: "20px",
                        marginRight: "30px",
                        color: "green",
                      }}
                    />
                    {pbPackage.bullet1}
                  </div>

                  <div className="w-100 d-flex justify-content-start feature-text">
                    <i
                      className="fas fa-check pl-2"
                      style={{
                        fontSize: "20px",
                        marginRight: "30px",
                        color: "green",
                      }}
                    />
                    {pbPackage.bullet2}
                  </div>

                  <div className="w-100 d-flex justify-content-start feature-text">
                    <i
                      className="fas fa-check pl-2"
                      style={{
                        fontSize: "20px",
                        marginRight: "30px",
                        color: "green",
                      }}
                      />
                      {pbPackage.bullet3}
                    </div>
                  </div>
                )}

                {/* from price */}
                {/* <div className="w-100 d-flex flex-column justify-content-center">
                  {fromPrice < Number.MAX_VALUE && (
                    <>
                      <p
                        className="m-0 p-0"
                        style={{
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "green",
                          textAlign: "center",
                        }}
                      >
                        From:{" "}
                        <span style={{ fontSize: "25px" }}>
                          ${fromPrice.toFixed(2)}
                        </span>
                      </p>
                    </>
                  )}
                  {fromPrice == Number.MAX_VALUE && (
                    <p className="font-italic text-center text-danger">No Rates Available</p>
                  )}
                </div> */}

                {/* {fromPrice < Number.MAX_VALUE && (
                )} */}
                <Button
                  className="w-100 widget-font box-shadow m-0 p-0"
                  variant="primary"
                  block
                  size="lg"
                  style={{
                    backgroundColor: "#EE6E24",
                    // boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "4px",
                    // marginTop: "50px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    border: "none",
                    marginBottom: "15px",
                    padding: "6px",
                  }}
                  onClick={() => onSelectedPackage(pbPackage)}
                >
                  View Package
                  </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {/* viewPortBreakPoint >= ViewPort.lg &&  */props.stacked && (
        <Col xs={12} className="p-3" style={{
          border: "solid",
          borderRadius: "8px",
          borderWidth: "1px",
          borderColor: "rgb(133, 133, 133)",
        }}>
          <Row className="w-100">
            <Col className="d-flex flex-column" xs={12}>
              <ValidPackageRange 
                packageName={pbPackage.packageName}
                fromPrice={pbPackage.fromPrice}
                validToTravelFrom={pbPackage.validToTravelFrom}
                validToTravelEnd={pbPackage.validToTravelEnd}
                fontColor={style.fontColor}
              />

              {/* Feature text */}
              {/*<div className="w-100 pl-2 pb-3">
                <div className="font-weight-bold" style={{ color: style.fontColor }}>
                  -<span className="pl-3">{pbPackage.bullet1}</span>
                </div>

                <div className="font-weight-bold" style={{ color: style.fontColor }}>
                  -<span className="pl-3">{pbPackage.bullet2}</span>
                </div>

                <div className="font-weight-bold" style={{ color: style.fontColor }}>
                  -<span className="pl-3">{pbPackage.bullet3}</span>
                </div>
              </div>*/}
            </Col>
          </Row>

          <Row className="w-100">
            <Col xs={12}>
              <div className="w-100">
                {/* <p
                  className="p-1 px-3 text-center"
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(208,205,212,.75)",
                  }}
                >
                  Card Text
                  </p> */}
                <Image
                  // className="d-flex lodging-image"
                  src={errorsImg ? errorsImg : (pbPackage.packageImageUrl ? pbPackage.packageImageUrl : placeholderImgUrl)}
                  onError={() => setErrorsImg(placeholderImgUrl)}
                  style={{height: "150px", width: "100%"}}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Button
              className="w-100 widget-font box-shadow m-0 p-0 mt-2"
              variant="primary"
              block
              //size="lg"
              style={{
                backgroundColor: "#EE6E24",
                borderRadius: "4px",
                color: "#FFFFFF",
                fontWeight: "bold",
                border: "none",
                marginBottom: "15px",
                padding: "6px",
              }}
              onClick={() => onSelectedPackage(pbPackage)}
            >
              View Package
              </Button>
          </Row>
        </Col>
      )}

      {/* Mobile */}
      {/* {viewPortBreakPoint < ViewPort.lg && (
        <Row className="mobile-card-container mobile-card-border">
          {false && (
            <Col xs={5}>
              <div className="w-100 pb-3">
                <p
                  className="w-100 p-1 pl-2"
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(208,205,212,.75)",
                  }}
                >
                  Card Text
                </p>
                <Image
                  className="d-flex mobile-lodging-image"
                  src={errorsImg ? errorsImg : (pbPackage.packageImageUrl ? pbPackage.packageImageUrl : placeholderImgUrl)}
                  onError={() => setErrorsImg(placeholderImgUrl)}
                  fluid
                />
              </div>
            </Col>
          )}

          <Col xs={12} className="pl-3 pb-3 d-flex flex-column justify-content-between align-items-center">
            <div className="text-center">
              <h5 className="font-weight-bold">
                {pbPackage.packageName}
              </h5>
              <p className="font-italic font weight-light" style={{ color: "grey" }}>Awesome place to be!</p>
            </div>

            <div className="w-100 d-flex flex-column justify-content-center">
              {fromPrice < Number.MAX_VALUE && (
                <>
                  <p
                    className="m-0 p-0"
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color: "green",
                      textAlign: "center",
                    }}
                  >
                    From:{" "}
                    <span style={{ fontSize: "25px" }}>
                      ${fromPrice.toFixed(2)}
                    </span>
                  </p>
                </>
              )}
              {fromPrice == Number.MAX_VALUE && (
                <p className="font-italic text-center text-danger">No Rates Available</p>
              )}
            </div>

            {fromPrice < Number.MAX_VALUE && (
              <div className="w-100 px-4">
                <Button
                  className="w-100 widget-font m-0 p-0"
                  variant="primary"
                  block
                  size="lg"
                  style={{
                    backgroundColor: "#EE6E24",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "4px",
                    // marginTop: "50px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    border: "none",
                    marginBottom: "15px",
                    padding: "6px",
                  }}
                  onClick={() => onSelectedPackage(pbPackage)}
                >
                  View
              </Button>
              </div>
            )}
          </Col>
        </Row>
      )} */}
    </React.Fragment>
  );
}

export default PackagesCard;